<script>
	import configuration from '../configuration.json';
    import app from '../data/app.svelte.js';
    import persistent from '../data/persistent.svelte';
    import { currentSession, currentSessionId } from '../data/session.svelte.js';

    import { _ } from 'svelte-i18n';
    import Icon from '../components/Icon.svelte';
    import arrowRightIcon from '../assets/icons/arrow-right.svg?raw';

    import Section from '../components/Section.svelte';
    import Status from '../components/Status.svelte';
    import Navigation from '../components/Navigation.svelte';
    import Button from '../components/Button.svelte';

    let url = $derived(window.location.origin + '/' + currentSession.client + '/' + currentSession.salon);

</script>

<svelte:head>
    <title>{$_('appointment_title')} - {$_('cancelled')}</title>
</svelte:head>

<Section title={$_('cancelled')}>
    <Status icon="error">
        {$_('appointment_cancelled')}
    </Status>

    <p>
        {$_('appointment_cancelled_description')}
    </p>

    <Navigation>
        <Button href={url}>
            {$_('make_another_appointment')}
            <Icon data={arrowRightIcon} />
        </Button>
    </Navigation>
</Section>
